import * as z from "zod/v4";
import { InventoryViewType } from "./inventory-view-type";

export const deleteInventoryViewFolder = {
  name: "deleteInventoryViewFolder" as const,
  input: z.object({ viewType: InventoryViewType, folderId: z.string() }),
  output: z.object({}),
};
